if (!customElements.get("reviews-grid")) {
  customElements.define(
    "reviews-grid",
    class BannerCards extends HTMLElement {
      constructor() {
        super();
        this.reviews = this.querySelectorAll(".reviews-pair");
        this.showMore = this.querySelector(".reviews-grid__show-more");
        this.sliderEl = this.querySelector(".reviews-grid__slider");

        this.splide = null;        
        this.desktopQuery = "(min-width: 768px)";

        // Bind handlers (bind this so that this is always our element even when you call it inside event listener)
        this.initialize = this.initialize.bind(this);
        this.onResizeRaf = null;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.handleShowMore();
        if (window.Splide) {
          this.initialize();
        } else {
          window.addEventListener("load", () => {
            this.initialize();
          }, { once: true });
        }
        window.addEventListener("resize", this.handleResize, { passive: true });
      }

      handleResize() {
        if (this.onResizeRaf) return;
        this.onResizeRaf = requestAnimationFrame(() => {
          this.onResizeRaf = null;
          this.initialize();
        });
      }

      initialize() {
        const shouldHaveSlider = window.innerWidth > 767;

        if (shouldHaveSlider) {
          if (this.sliderEl && !this.splide) {
            this.initSlider(this.sliderEl);
          }
        } else {
          if (this.splide) {
            this.splide.destroy(true);
            this.splide = null;
          }
        }
      }

      handleShowMore() {
        if (!this.showMore) return;

        this.showMore.addEventListener("click", () => {
          let counter = 0;

          for (let i = 0; i < this.reviews.length; i++) {
            const review = this.reviews[i];
            if (review.classList.contains("reviews-grid__review-hidden")) {
              review.classList.remove("reviews-grid__review-hidden");
              counter++;
              if (counter >= 2) break;
            }
          }

          const hiddenLeft = Array.from(this.reviews).some((r) =>
            r.classList.contains("reviews-grid__review-hidden")
          );
          if (!hiddenLeft) {
            this.showMore.style.display = "none";
          }
        });
      }

      initSlider(sliderElement) {
        if (!window.Splide) return; 

        const options = {
          classes: {
            arrows: "splide__arrows",
            arrow: "splide__arrow",
            prev: "splide__arrow--prev custom-prev",
            next: "splide__arrow--next custom-next",
          },
          perMove: 1,
          drag: true,
          pagination: false,
          arrows: true,
          autoWidth: true,
        };

        this.splide = new Splide(sliderElement, options);
        this.splide.mount();
      }
    }
  );
}
